<template>
    <pm-app-component hide-sidebar bar-color="#9696a0!important">
        <!--template slot="title">
            {{ $t('plan_calculator.plan_number', { n: activePlan + 1 }) }}
        </template-->

        <template slot="mobile-toolbar">
            <pm-application-bar>
                {{ $t('menu.calculator') }}
            </pm-application-bar>
        </template>

        <div class="pm-simple-plan--overview-header x-pm-animation-fade-in-slide-down" :style="'--delay: 0ms'" style="box-shadow: 0 0 10px rgba(0,0,150,.08); z-index: 1; position: absolute; top: 5px; left: 0; right: 0;" :class="$theme.baseBg">
            <div :class="[$theme.defaultText, $theme.contentBg]" class="overview--title-wrapper" style="padding: 15px 0 15px 0;">
                <div class="text-xs-center">
                    <span class="bold--text overview--title roboto" style="font-size: 20px">{{ $t("plan_calculator.total") }}
                        <span class="overview--title roboto f14">({{ $t('plan_calculator.upper').toLowerCase() }} + {{ $t('plan_calculator.lower').toLowerCase() }})</span>
                    </span>
                    <br>
                    <pm-price class="roboto calculator-total-price" style="font-weight: 600; font-size: 24px;" :currency="currency" :value="plans[activePlan].fullTotal" />
                </div>
            </div>
        </div>

        <div class="pm-simple-plan--overview-content" style="position: absolute; top: 100px; bottom: 0px; left: 0; right: 0; overflow-y: auto; -webkit-overflow-scrolling: touch; scroll-behavior: smooth;">


            <pm-pdf-preview :plan="plans[activePlan]" />

                <div v-for="(jaw, i) in groups" :key="jaw" class="pm-animation-fade-in-slide-down" :style="'--delay: '+i * 150+'ms'">
                    <div v-if="groupByJaws" style="display: flex; padding: 8px 16px;" :class="[$theme.baseBg, $theme.defaultText]" :style="jaw!=='upper' ? 'box-shadow: inset 0 8px 15px rgba(0,0,0,.03);' : ''">
                        <span class="overview--sub-title roboto f16 bold--text">{{ $t('plan_calculator.' + jaw) }}</span>
                        <div style="flex-grow: 1" />
                        <pm-price :class="$theme.defaultText" class="roboto bold--text f16 overview--price" :currency="$store.state.currency" :value="plans[activePlan].total[jaw]" />
                    </div>
                    <div v-else style="height: 3px;"></div>

                    <div :class="$theme.contentBg" style="box-shadow: 0 8px 15px rgba(0,0,0,.03);">
                        <template v-if="Object.keys(plans[activePlan].steps[jaw]).length > 0">
                            <div @click="() => { activeJaw = jaw; addExtraTreatmentsDialog = true; }" style="border-bottom: 1px solid #eee; padding: 10px 16px; display: flex; align-items: center;" v-for="(amount, stateId) in plans[activePlan].steps[jaw]" class="treatment--row">
                                <div class="calculator-offer-row-title">
                                    <span style="font-family: 'Roboto', sans-serif; color: #000;" class="treatment--amount-title">{{ $store.getters['smart/titleOfTreatment'](stateId, $store.state.language, true) }}</span>
                                    <br/>
                                    <span style="font-size: 12px; color: rgb(123, 128, 136);" class="treatment--amount">
                                        {{ amount }} &times; <pm-price :value="$store.getters['smart/priceOfTreatment'](stateId, $store.state.currency)" hide-currency />
                                    </span>
                                </div>
                                <div style="flex-grow: 0; flex-shrink: 0; width: 100px; text-align: right;">
                                    <pm-price style="font-weight: 600!important;" :value="amount * $store.getters['smart/priceOfTreatment'](stateId, $store.state.currency)" :currency="$store.state.currency" />
                                </div>
                            </div>
                        </template>
                        <div style="text-align: center">
                            <v-btn
                                large
                                flat
                                class="grey--text text--darken-1 transparent elevation-0"
                                :style="Object.keys(plans[activePlan].steps[jaw]).length > 0 ? 'margin: 16px 0 16px 0;' : 'margin: 32px 0 32px 0;'"
                                style="font-size: 14px; background: rgb(170, 170, 180)!important; color: #fff!important; height: 40px; padding-left: 16px; padding-right: 22px; border: 0px solid #dfe1e3!important; border-radius: 24px;"
                                @click="() => { activeJaw = jaw; addExtraTreatmentsDialog = true; }"
                            >
                                <v-icon style="margin-right: 10px;">
                                    add
                                </v-icon> <span style="font-weight: 600">{{ $t('plan_calculator.treatment') }}</span> <span style="font-size: 12px;" v-if="['upper','lower'].includes(jaw)">&nbsp;({{ $t('plan_calculator.' + jaw).toLowerCase() }})</span>
                            </v-btn>
                        </div>
                    </div>
                </div>
        </div>

        <pm-add-extra-treatments v-model="addExtraTreatmentsDialog" @select="updateSteps" :activeJaw="activeJaw" :steps="plans[activePlan].steps[activeJaw]" />

        <!-- <pm-welcome-screen v-if="onboarding.length > 0" :steps="onboarding" /> -->

        <!-- <pm-pdf-viewer v-model="pdfData" v-if="pdfData !== null" /> -->


    </pm-app-component>
</template>

<style>

@keyframes pmAnimationFadeInSlideDown {
    0% {
        transform: translateY(-30px);
        opacity: 0;
    }
    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

.pm-animation-fade-in-slide-down {
    opacity: 0;
    will-change: opacity, transform;
    animation-name: pmAnimationFadeInSlideDown;
    animation-timing-function: ease-in-out;
    animation-duration: .3s;
    animation-delay: var(--delay);
    animation-fill-mode: forwards;
}

@keyframes pmAnimationFadeInScale {
    0% {
        transform: scale(0.8);
        opacity: 0;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.pm-animation-fade-in-scale {
    opacity: 0;
    will-change: opacity, transform;
    animation-name: pmAnimationFadeInScale;
    animation-timing-function: ease-in-out;
    animation-duration: .3s;
    animation-delay: var(--delay);
    animation-fill-mode: forwards;
}

.calculator-total-price small {
    font-weight: 600;
}

.overview--title-wrapper {
    margin-top: 0;
}

.calculator-offer-row-title {
    flex-grow: 1; flex-shrink: 1; line-height: 1.3;
}

@media (min-width: 700px) {

    .overview--title-wrapper {
        margin-top: -4px;
    }

    .overview--price {
        display: flex;
        align-items: center;
        justify-content: space-between;
        /* width: 26px; */
        margin-right: 10px;
        font-size: 22px !important;
    }

    .overview--title {
        font-size: 26px !important;
    }
    .calculator-total-price {
        font-size: 32px !important;
    }
    .overview--title.f14 {
        font-size: 16px !important;
    }

    .treatment--row {
        padding: 10px 28px !important;
    }

    .treatment--row:not(.treatment--amount) {
        font-size: 17px !important;
    }

    .treatment--row:not(.treatment--amount span) {
        font-size: 18px !important;
    }

    .treatment--amount,
    .treatment--amount span {
        font-size: 16px !important;
    }

    .pm-simple-plan--overview-content {
        top: 110px !important;
    }

    .pm-simple-plan--overview-content .overview--sub-title {
        font-size: 20px !important;
        margin-left: 10px;
    }

    /* .pm-simple-plan--overview-content span {
        font-size: 20px !important;
    } */

    .pm-simple-plan--overview-content .v-btn.v-btn--large {
        margin: 44px 0 !important;
        height: 50px !important;
        border-radius: 40px !important;
        font-size: 20px !important;
    }

    .pm-simple-plan--overview-content .v-btn.v-btn--large span + span {
        font-size: 16px !important;
        margin-top: 4px;
    }

    .pm-simple-plan--overview-header {
        position: relative !important;
    }

    .pm-simple-plan--overview-content {
        top: 120px !important;
    }
}
</style>

<script>

import ToolbarMixin from "../../extensions/mixins/mixin-toolbar";
import PmAddExtraTreatments from "./add-extra-treatments";
import PmStepStepper from "./step-stepper";
import AdManager from "@/extensions/managers/ad-manager";
import PmPdfPreview from "./pdf.vue";

import { onboarding } from "./onboarding.js";
import { downloadPdf, getPdfFileUrl } from "../../utils/pdf";
import { isDev } from "../../utils/debug/is-dev";
// import PmPdfViewer from "../dialogs/pdf-viewer.vue";

import { invokeFlutterService } from '@/utils/flutter/flutter-service';

export default {
    components: {
        PmAddExtraTreatments,
        PmStepStepper,
        PmPdfPreview,
        // PmPdfViewer,
    },
    mixins: [
        ToolbarMixin,
    ],
    data() {
        return ({
            currency: this.$store.state.currency,
            plans: [],
            activePlan: 0,
            activeJaw: "other",
            addExtraTreatmentsDialog: false,
            firstRun: false,
            groupByJaws: true,
            groups: ['upper','lower'],
            // pdfData: null,
            pdfProcessing: false,
        });
    },
    toolbar: function() {
        const items = this.getToolbarItems();
        return ([items]);
    },

    watch: {
        groupByJaws(val) {
            if (val) {
                this.groups = ['upper','lower'];
            }  else {
                this.groups = ['other'];
            }
            this.calculateTotal();
            localStorage.setItem('calculatorMode', this.groupByJaws);
        },
        addExtraTreatmentsDialog(nextValue, prevValue) {
            // Open treatment dialog.
            if (nextValue === true) {
                return window.Tracker.logEvent({
                    event_label: '',
                    event_name: '',
                    event_value: 0,
                });
            }

            window.Tracker.logEvent({
                event_label: '',
                event_name: '',
                event_value: 0,
            });
        },
    },
    created() {
        try {
            const mode = localStorage.getItem('calculatorMode');
            if (mode) {
                this.groupByJaws = mode === "true";
            }
        } catch(error) {
            captureException(error);
        }

        this.createPlan();

        try {
            const saved = localStorage.getItem('calculation');
            if (saved) {
                this.plans[this.activePlan].steps = JSON.parse(atob(saved));
                this.calculateTotal();
            }
        } catch(error) {
            captureException(error);
            this.reset();
        }

        this.onboarding = onboarding();
    },

    beforeRouteLeave(to, from, next) {
        try {
            const data = this.plans[this.activePlan].steps;
            localStorage.setItem('calculation', btoa(JSON.stringify(data)));

            window.Tracker.logEvent({
                event_label: 'treatmentSelectCount',
                event_name: 'treatment_select',
                event_value: parseInt(localStorage.getItem('treatmentSelectCount') || '0', 10),
            });

            localStorage.setItem('treatmentSelectCount', '0');
        } catch(error) {
            captureException(error);
        }
        next();
    },

    beforeRouteEnter(to, from, next) {
        if (window.packageName && !['com.denticalc.calculator', 'com.denticalc.4in1'].includes(window.packageName)) return(next({name: "home"}));
        AdManager.logRouteView('calculator');
        // AdManager.show('calculator');
        return next();
    },

    mounted() {
        if (!this.$IAP.hasAccessToComponent('photos')) {
            // this.$bus.$emit('openAppDialog','userEmail');
            // this.$bus.$emit('openAppDialog','premium',{'title': '', 'referrer': 'auto_calc'});
        }

        const els = document.querySelectorAll('.pm-animation-fade-in-slide-down');
        els.forEach((el) => {
            el.addEventListener('animationend', (event) => {
                if (event.target instanceof HTMLElement) {
                    event.target.style.willChange = 'auto';
                }
            });
        })

        if (window["packageName"] === "com.denticalc.calculator") {

            window.setTimeout(() => {
                invokeFlutterService('FlutterIsVueMountedService', "mounted");
            }, 150);

            try {
                /**
                 * @typedef {object} Payload
                 * @property {string} command
                 * @property {object} data
                 */

                /** @type {Payload} */
                const payload = {command: "hook", data: {name: "mounted"}};
                invokeFlutterService("SemaphoreChannel", JSON.stringify(payload));
            } catch(error) {
                captureException(error);
            }
        }
    },

    methods: {
        getToolbarItems() {
            const items = [];

            // items.push({
            //     placeholder: true,
            // });

            items.push({
                icon: "coin",
                text: this.$t("menu.pricelist"),
                callback: () => {
                    this.$router.push("/pricelist");
                },
            });

            items.push({
                mdi: "printer",
                text: "Print",
                callback: () => {
                    this.print();
                },
            });

            items.push({
                icon: "reset",
                text: this.$t("core.reset"),
                callback: () => {
                    this.reset();
                },
            });

            if (!window.packageName || window.packageName === "com.denticalc.4in1") {
                items.push({
                    // disabled: true,
                    back: true,
                    callback: () => {
                        this.$router.push("/");
                    },
                });
            }

            return items;
        },


        print() {
            if (!window.IAP.hasAccessToComponent('pdf')) {
                // this.$bus.$emit('extra-features-dialog:show');
                this.$bus.$emit('openAppDialog','premium', { 'referrer': 'auto_calc_pdf' });
                return;
            }

            if (this.pdfProcessing) return;
            this.pdfProcessing = true;

            this.$bus.$emit("app.showSnackbar", {color: "blue", text: "Generating PDF...", timeout: 30000});

            const content = document.getElementById("pdf-content").innerHTML;
            request
                .post("https://denticalcsrvc.planmaster.hu/pdfPrint")
                .send({
                    footer: "",
                    content: content,
                })
                .withCredentials(false)
                .set("accept", "text/html")
                .then((resp) => {
                    console.log(resp);
                    // this.processing = false;
                    this.pdfProcessing = false;
                    // downloadPdf(resp.body.base64data);
                    // this.pdfUrl = getPdfFileUrl(resp.body.base64data);
                    this.$bus.$emit("app.hideSnackbar");
                    if (typeof resp.body !== 'undefined' && typeof resp.body.preview !== 'undefined' && resp.body.preview.length > 0) {
                        // this.pdfData = resp.body;
                        this.$bus.$emit('openAppDialog', 'pdfViewerGdocs', { pdfUrl: resp.body.url, pdfPages: resp.body.pages });
                    }
                    else this.$bus.$emit("app.showSnackbar", {color: "red", text: "Error creating PDF"}, 6);
                })
                .catch((error) => {
                    console.error(error);
                    captureException(error);
                    this.$bus.$emit("app.showSnackbar", {color: "red", text: "Error creating PDF"}, 6);
                    this.pdfProcessing = false;
                });

        },

        openPlan(idx) {
            if (typeof this.plans[idx] === "undefined") return false;
            this.activePlan = idx;
            this.$store.commit("toolbar/setItems", this.getToolbarItems());
            // this.$store.commit('toolbar/show');
            // this.$bus.$emit('app-buttonbar:update', items);
        },

        deletePlan(i) {
            this.plans.splice(i, 1);
            if (i === 0) this.activePlan = 0;
            else this.activePlan = i - 1;
            this.openPlan(this.activePlan);
        },

        reset() {
            Object.keys(this.plans[this.activePlan].steps.upper).forEach((key) => {delete this.plans[this.activePlan].steps.upper[key];});
            Object.keys(this.plans[this.activePlan].steps.lower).forEach((key) => {delete this.plans[this.activePlan].steps.lower[key];});
            Object.keys(this.plans[this.activePlan].steps.other).forEach((key) => {delete this.plans[this.activePlan].steps.other[key];});
            this.calculateTotal();
            this.$forceUpdate();
        },

        createPlan() {
            const plan = {
                steps: {
                    upper: {},
                    lower: {},
                    other: {},
                },
                fullTotal: 0,
                total: {
                    upper: 0,
                    lower: 0,
                    other: 0,
                },
            };
            this.plans.push(plan);
            this.activePlan = this.plans.length - 1;
            this.openPlan(this.activePlan);
        },

        updateExtra(id, jaw, value) {
            const steps = this.plans[this.activePlan].steps[jaw];
            this.$set(steps, String(id), value);
            this.$forceUpdate();
            this.calculateTotal();
        },

        increaseExtra(id, jaw) {
            const steps = this.plans[this.activePlan].steps[jaw];
            this.$set(steps, String(id), steps[String(id)] + 1);
            this.$forceUpdate();
            this.calculateTotal();
        },

        decreaseExtra(id, jaw) {
            const steps = this.plans[this.activePlan].steps[jaw];
            if (steps[String(id)]<=0) steps[String(id)] = 1;
            this.$set(steps, String(id), steps[String(id)] - 1);
            this.$forceUpdate();
            this.calculateTotal();
        },

        updateSteps(extraStepAmounts) {
            this.plans[this.activePlan].steps[this.activeJaw] = {};
            const steps = this.plans[this.activePlan].steps[this.activeJaw];
            Object.keys(extraStepAmounts).forEach((stateId) => {
                if (extraStepAmounts[String(stateId)] <= 0) return;
                if (typeof steps[String(stateId)] === "undefined") steps[String(stateId)] = 0;
                steps[String(stateId)] = extraStepAmounts[String(stateId)];
            });
            this.calculateTotal();
        },

        addSteps(extraStepAmounts) {
            const steps = this.plans[this.activePlan].steps[this.activeJaw];
            Object.keys(extraStepAmounts).forEach((stateId) => {
                if (extraStepAmounts[String(stateId)] <= 0) return;
                if (typeof steps[String(stateId)] === "undefined") steps[String(stateId)] = 0;
                steps[String(stateId)] += extraStepAmounts[String(stateId)];
            });
            this.calculateTotal();
        },

        calculateTotal() {
            this.plans[this.activePlan].total["upper"] = this.calculateJaw("upper");
            this.plans[this.activePlan].total["lower"] = this.calculateJaw("lower");
            this.plans[this.activePlan].total["other"] = this.calculateJaw("other");

            if(this.groupByJaws) {
                this.plans[this.activePlan].fullTotal = this.plans[this.activePlan].total["upper"] + this.plans[this.activePlan].total["lower"];
            } else {
                this.plans[this.activePlan].fullTotal = this.plans[this.activePlan].total["other"];
            }


        },

        calculateJaw(jaw) {
            const steps = this.plans[this.activePlan].steps[jaw];
            if (typeof steps === "undefined") return 0;
            let total = 0;
            for (const id of Object.keys(steps)) {
                const unitPrice = this.$store.getters["smart/priceOfTreatment"](id, this.$store.state.currency);
                total += unitPrice * steps[String(id)];
            }
            return total;
        },
    },
};
</script>
